import {computed, Injectable, signal} from '@angular/core';

export interface LegendItem {
  label: string;
  color: string;
  count?: number;
}

@Injectable({
  providedIn: 'root',
})
export class LegendService {

  constructor() { }

  private readonly _byHandle = signal<Record<string, LegendItem[]>>({});

  set(uiHandle: string, items: LegendItem[]): void {
    const curr = this._byHandle();
    this._byHandle.set({ ...curr, [uiHandle]: items });
  }

  get(uiHandle: string) {
    // expose as a computed signal so consumers can read it directly
    return computed(() => this._byHandle()[uiHandle] ?? []);
  }

  clear(uiHandle: string): void {
    const copy = {...this._byHandle()};
    delete copy[uiHandle];
    this._byHandle.set(copy);
  }
}
